(function () {
  'use strict';

  angular.module('sempraWebapp').service('exportToCsv', exportToCsvService);

  /** @ngInject */
  function exportToCsvService(brand, $filter) {
    /* eslint-disable */
    this.export = function (jsonDataArray, reportTitle, showLabel) {
      var csv = serializeJsonToCsv(jsonDataArray, reportTitle, showLabel);
      if (csv) {
        saveToFile(csv, reportTitle);
      }
    };

    this.exportBasicArrayToCsv = function (data, reportTitle) {
      if (!data || !data.length) {
        console.error('No data available for CSV export.');
        return;
      }

      // Filter out $$hashKey from headers
      var headers = Object.keys(data[0]).filter(function (key) {
        return key !== '$$hashKey';
      });

      var csvRows = [];
      csvRows.push(headers.join(','));

      data.forEach(function (row) {
        var values = headers.map(function (header) {
          var value = row[header] === undefined || row[header] === null ? '' : row[header];

          if (typeof value === 'number' && value.toString().length >= 10) {
            value = $filter('date')(value, 'dd/MM/yy - HH:mm');
          }

          return typeof value === 'string' &&
          (value.indexOf(',') !== -1 || value.indexOf('\n') !== -1)
            ? '"' + value.replace(/"/g, '""') + '"'
            : value;
        });
        csvRows.push(values.join(','));
      });

      var csvString = csvRows.join('\n');
      var blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      var downloadLink = document.createElement('a');
      var url = window.URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = reportTitle;
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    };

    function serializeJsonToCsv(jsonData, reportTitle, showLabel) {
      if (!jsonData) {
        return null;
      }

      //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData =
        typeof jsonData != 'object' ? JSON.parse(jsonData) : jsonData;

      var CSV = '';

      //Set Report title in first row or line
      CSV += reportTitle + '\r\n\n';

      //This condition will generate the Label/Header
      if (showLabel) {
        var row = '';

        //This loop will extract the label from 1st index of on array
        for (var index in arrData[0]) {
          //Now convert each value to string and comma-separated
          row += index + ',';
        }

        row = row.slice(0, -1);

        //append Label row with line break
        CSV += row + '\r\n';
      }

      //1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        var row = '';

        //2nd loop will extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {
          row += '"' + arrData[i][index] + '",';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + '\r\n';
      }

      return CSV === '' ? null : CSV;
    }

    function saveToFile(csvData, reportTitle) {
      //Generate a file name (depending on color/company name)
      var fileName;
      switch (brand) {
        case 'karcher':
          fileName = '';
          break;
        default:
          fileName = 'R2W_';
          break;
      }
      //this will remove the blank-spaces from the title and replace it with an underscore
      fileName += reportTitle.replace(/ /g, '_');

      var link = document.createElement('a');

      if (navigator.msSaveBlob) {
        // IE 10+
        link.addEventListener(
          'click',
          function () {
            var blob = new Blob([csvData], {
              type: 'text/csv;charset=utf-8;'
            });
            navigator.msSaveBlob(blob, fileName + '.csv');
          },
          false
        );
      } else {
        var url = 'data:text/csv;charset=utf-8,' + escape(csvData);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName + '.csv');
        link.setAttribute('target', '_blank');
        link.style.visibility = 'hidden';
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    /* eslint-enable */
  }
})();
